import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Placeholder images for the gallery
const GALLERY_IMAGES = [
  {
    id: 1,
    src: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952',
    alt: 'Home Cleaning',
    category: 'home'
  },
  {
    id: 2,
    src: 'https://images.unsplash.com/photo-1628177142898-93e36e4e3a50',
    alt: 'Office Cleaning',
    category: 'office'
  },
  {
    id: 3,
    src: 'https://images.unsplash.com/photo-1527515637462-cff94eecc1ac',
    alt: 'Carpet Cleaning',
    category: 'carpet'
  },
  {
    id: 4,
    src: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952',
    alt: 'Window Cleaning',
    category: 'window'
  },
  {
    id: 5,
    src: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a',
    alt: 'Bathroom Cleaning',
    category: 'home'
  },
  {
    id: 6,
    src: 'https://images.unsplash.com/photo-1556911220-bff31c812dba',
    alt: 'Kitchen Cleaning',
    category: 'home'
  },
  {
    id: 7,
    src: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea',
    alt: 'Commercial Cleaning',
    category: 'office'
  },
  {
    id: 8,
    src: 'https://images.unsplash.com/photo-1527515673510-8aa78ce21f9b',
    alt: 'Facade Cleaning',
    category: 'facade'
  }
];

const GalleryContainer = styled.div`
  padding: 60px 0;
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 40px;
`;

const GalleryItem = styled.div`
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const GalleryImage = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
  display: block;
`;

const GalleryCaption = styled.div`
  padding: 15px;
  background-color: white;
  text-align: center;
  font-weight: 600;
  color: #2e7d32;
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 10px;
`;

const FilterButton = styled.button<{ active: boolean }>`
  padding: 8px 16px;
  background-color: ${props => props.active ? '#2e7d32' : 'white'};
  color: ${props => props.active ? 'white' : '#2e7d32'};
  border: 1px solid #2e7d32;
  border-radius: 5px;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${props => props.active ? '#1b5e20' : '#e8f5e9'};
  }
`;

const Gallery: React.FC = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = React.useState('all');
  
  const filteredImages = filter === 'all' 
    ? GALLERY_IMAGES 
    : GALLERY_IMAGES.filter(img => img.category === filter);
  
  return (
    <GalleryContainer>
      <div className="container">
        <h2 className="section-title">{t('gallery_title')}</h2>
        
        <FilterContainer>
          <FilterButton 
            active={filter === 'all'} 
            onClick={() => setFilter('all')}
          >
            الكل
          </FilterButton>
          <FilterButton 
            active={filter === 'home'} 
            onClick={() => setFilter('home')}
          >
            تنظيف المنازل
          </FilterButton>
          <FilterButton 
            active={filter === 'office'} 
            onClick={() => setFilter('office')}
          >
            تنظيف المكاتب
          </FilterButton>
          <FilterButton 
            active={filter === 'carpet'} 
            onClick={() => setFilter('carpet')}
          >
            تنظيف السجاد
          </FilterButton>
          <FilterButton 
            active={filter === 'facade'} 
            onClick={() => setFilter('facade')}
          >
            تنظيف الواجهات
          </FilterButton>
        </FilterContainer>
        
        <GalleryGrid>
          {filteredImages.map(image => (
            <GalleryItem key={image.id}>
              <GalleryImage src={`${image.src}/300x250`} alt={image.alt} />
              <GalleryCaption>{image.alt}</GalleryCaption>
            </GalleryItem>
          ))}
        </GalleryGrid>
      </div>
    </GalleryContainer>
  );
};

export default Gallery;
